import type { HealthData } from "@icraftx/shared/v1";
import { apiGet } from "./client";

export function fetchHealth(): Promise<HealthData> {
  return apiGet<HealthData>("/health");
}
